import React from 'react';
import * as core from '#packages/core';
import * as stateManagement from '#packages/stateManagement';
import constants from '#packages/constants';
import * as helpIds from '#packages/helpIds';
import { hoc } from '#packages/util';
import { createSelector } from '../../selectors/selector';
import { editorStateSel } from '../selectors/rootSelectors';
import { mapStateToProps, type PinModeStateProps } from './pinModeMapper';
import styles from './pinMode.scss';
import type { EditorState } from '#packages/stateManagement';

const { getSessionUserPreferences } = stateManagement.userPreferences.selectors;

interface PinModeProps extends PinModeStateProps {}

class PinMode extends React.Component<PinModeProps> {
  static displayName: 'pinMode';

  static contextTypes = core.mixins.editorAPIMixin.contextTypes;
  getEditorAPI = core.mixins.editorAPIMixin.getEditorAPI.bind(this);

  render() {
    return (
      <div className={styles.pinMode}>
        <div
          style={this.props.pinPreviewRectStyle}
          className={styles.previewRect}
        />
        <div onClick={this.exitPinMode} className={styles.blockingLayer} />
      </div>
    );
  }

  exitPinMode = () => {
    const editorAPI = this.getEditorAPI();
    const pinToScreenCount =
      getSessionUserPreferences(constants.USER_PREFS.PIN_TO_SCREEN.PIN_COUNT)(
        editorAPI.store.getState(),
      ) || 0;
    if (pinToScreenCount === 0) {
      const onNotificationLinkClick = () => {
        editorAPI.panelManager.openHelpCenter(
          helpIds.NOTIFICATIONS.PIN_TO_SCREEN,
        );
      };
      editorAPI.store.dispatch(
        stateManagement.notifications.actions.showUserActionNotification({
          message: 'Notifications_Pinned_Mobile_Text',
          title: 'Notifications_Pinned_Mobile_Text',
          type: 'info',
          link: {
            caption: 'Notifications_Pinned_Mobile_Link',
            onNotificationLinkClick,
          },
        }),
      );
      editorAPI.store.dispatch(
        stateManagement.userPreferences.actions.setSessionUserPreferences(
          constants.USER_PREFS.PIN_TO_SCREEN.PIN_COUNT,
          -4,
        ),
      );
    }

    editorAPI.pinMode.closeAndCheckSizeRestrictions();
  };
}

const shouldShowPinMode = createSelector(
  [editorStateSel],
  (editorState: EditorState) =>
    stateManagement.pinMode.selectors.isOpen(editorState),
);

const PinModeConnected = hoc.connect(
  hoc.STORES.EDITOR_API,
  mapStateToProps,
)(PinMode);

export default hoc.withConditionalRender(
  hoc.STORES.EDITOR_API,
  shouldShowPinMode,
)(PinModeConnected);
